var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nuxt-link',{staticClass:"product-select-bidding__submit-button btn btn-primary btn-lg btn-block text-uppercase",class:{ 'product-select-bidding__submit-button--disabled': _vm.disabled },attrs:{"to":_vm.checkoutLink}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.$t('BiddingCheckoutLink.placeBid')))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }